<nx-pageTitle-box class="mb-3"
  [label]="'core.jobAdmin.pageTitle.label'"
  [icon]="'icon-time'"
  [iconToolTip]="'core.jobAdmin.pageTitle.label'"
  [bcRootLvlLabel]="'Einstellungen'"
  [bcRootLvlPath]="'settings'">
</nx-pageTitle-box>

@if (loading() && !job()) {
  <div class="bg-white px-5 py-4 flex flex-row justify-center border-t border-gray">
    <p-progressSpinner [style]="{ width: '2rem', height: '2rem' }" strokeWidth="4"></p-progressSpinner>
  </div>
} @else if (error()) {
  <div class="bg-white px-5 py-4 text-[#c0123c] border-t border-gray">
    {{ 'core.jobAdmin.messages.loadError' | translate }}
  </div>
} @else if (notFound()) {
  <div class="bg-white px-5 py-4 border-t border-gray">
    <div class="mb-2">{{ 'core.jobAdmin.messages.jobNotFound' | translate }}</div>
    <nx-default-button [style]="'light'" (click)="backToList()" [label]="'core.jobAdmin.actions.backToList' | translate"></nx-default-button>
  </div>
} @else if (job()) {
  <div class="bg-white px-5 py-4 border-t border-gray">
    <div class="flex flex-row items-center gap-2 mb-2">
      <span class="font-medium">{{ job().key?.name }}</span>
      <span class="text-[#848488]">({{ job().key?.group }})</span>
    </div>
    <div class="text-[#848488] mb-1">{{ job().jobClass }}</div>
    @if (job().description) {
      <div class="mb-2">{{ job().description }}</div>
    }
    <div class="flex flex-row gap-2 mb-3">
      @for (command of job().commands; track command.name) {
        <nx-default-button
          [style]="'light'"
          [label]="command.settings?.label"
          [disabled]="command.settings?.disabled"
          (click)="onCommand(command)">
        </nx-default-button>
      }
    </div>
    <app-trigger-table [triggers]="job().jobTriggers" [reloadable]="self"></app-trigger-table>
  </div>
}
